import { getPlatformLabel, normalizeHashtagList } from "./campaignPayload";

function unwrapPost(data) {
    if (data?.post) return data.post;
    return data ?? {};
}

export function normalizePost(data) {
    const raw = unwrapPost(data);
    const hash_tags = normalizeHashtagList(raw.hash_tags ?? raw.hashTags);

    return {
        id: raw.id ?? raw._id ?? null,
        caption: raw.caption ?? "",
        hash_tags,
        hashTags: hash_tags,
        createdAt: raw.created_at ?? raw.createdAt ?? raw.created ?? null,
        campaignId: raw.campaign_id ?? raw.campaignId ?? null,
        campaignName:
            raw.campaign_name ??
            raw.campaignName ??
            raw.campaign?.name ??
            raw.basicDetails?.name ??
            null,
        platform: raw.platform ?? raw.campaign?.platform ?? raw.basicDetails?.platform ?? null,
        media: raw.media ?? null,
        asset_type: raw.asset_type ?? raw.assetType ?? null,
    };
}

export function normalizePostsResponse(data) {
    let posts = [];
    let hasCursorPagination = false;
    let hasMore = false;
    let lastDocId = null;

    if (Array.isArray(data)) {
        posts = data;
    } else if (Array.isArray(data?.posts)) {
        posts = data.posts;
        hasCursorPagination = data.has_more != null || data.last_doc_id != null;
        hasMore = Boolean(data.has_more);
        lastDocId = data.last_doc_id ?? null;
    } else if (Array.isArray(data?.data)) {
        posts = data.data;
        hasCursorPagination = data.has_more != null || data.last_doc_id != null;
        hasMore = Boolean(data.has_more);
        lastDocId = data.last_doc_id ?? null;
    }

    return {
        posts: posts.map(normalizePost),
        hasCursorPagination,
        hasMore,
        lastDocId,
    };
}

export function getPostTitle(post) {
    const caption = (post?.caption || "").trim();
    if (!caption) return "Untitled post";
    const firstLine = caption.split("\n")[0].trim();
    return firstLine.length > 100 ? `${firstLine.slice(0, 100)}…` : firstLine;
}

export function getPostDate(post) {
    return post?.createdAt ?? post?.created_at ?? post?.created ?? null;
}

export function getDisplayPlatform(post) {
    const value = post?.platform;
    return value ? getPlatformLabel(value) : null;
}
